module.exports = __webpack_public_path__ + "static/img/wy.29ae96a9.png";